import React, { useEffect, useState } from 'react';
import { EditSection, LoadingContainer } from '../../components/Layout';
import { Communicator } from '../../tools/Communication';
import i18n from '@/utils/i18n';

export const EditRiderAreaConfigPage: React.FC = () => {
  const [riderArea, setRiderArea] = useState<string>('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    Communicator.Get('/Config/GetConfigValue', {
      key: 'RiderArea',
    })
      .then((response) => response.text())
      .then((text) => setRiderArea(text || ''))
      .then(() => setIsLoading(false));
  }, []);

  async function handleSave() {
    setIsLoading(true);
    const result = await Communicator.PostData('/Config/SetConfigValue', {
      Key: 'RiderArea',
      Value: riderArea,
    });
    const area = await result.text();
    setRiderArea(area);
    setIsLoading(false);
  }

  if (isLoading) {
    return <LoadingContainer />;
  }

  return (
    <EditSection
      title={i18n.t('RiderArea:riderArea')}
      isLoading={isLoading}
      onSave={handleSave}
    >
      <div>
        <h2>{i18n.t('RiderArea:steps')}:</h2>
        <ol className="mt-4 mb-4">
          <li className="ms-5 mt-1 mb-1">{i18n.t('RiderArea:step1')}</li>
          <li className="ms-5 mt-1 mb-1">
            {i18n.t('RiderArea:step2')}:{' '}
            <a
              href="http://geojson.io/"
              target="_blank"
              rel="noopener noreferrer"
            >
              http://geojson.io/
            </a>
          </li>
          <li className="ms-5 mt-1 mb-1">{i18n.t('RiderArea:step3')}</li>
          <li className="ms-5 mt-1 mb-1">{i18n.t('RiderArea:step4')}</li>
          <li className="ms-5 mt-1 mb-1">{i18n.t('RiderArea:step5')}</li>
          <li className="ms-5 mt-1 mb-1">{i18n.t('RiderArea:step6')}</li>
          <li className="ms-5 mt-1 mb-1">{i18n.t('RiderArea:step7')}</li>
        </ol>
      </div>
      <div className="input-group mt-3 mb-3">
        <textarea
          rows={10}
          className="form-control"
          value={riderArea}
          onChange={(e) => setRiderArea(e.target.value)}
        />
      </div>
    </EditSection>
  );
};
